import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { Field } from 'redux-form';
import classNames from 'classnames';

import {
  messageTranslator,
  TRANSLATED_CLASS,
  MISSING_CLASS,
} from 'common/components/Intl';

const translatableProps = ['label', 'placeholder', 'noResultsText'];

const TranslatedField = ({ intl, className, ...props }) => {
  let missingMessage = false;
  const translatedProps = {};
  const translate = messageTranslator(intl);

  translatableProps.forEach(tp => {
    const prop = props[tp];
    if (prop) {
      const translatedMessage = translate(prop);
      translatedProps[tp] = translatedMessage;

      if (!missingMessage && translatedMessage == prop) {
        missingMessage = true;
      }
    }
  });

  return (
    <Field
      className={classNames(className, TRANSLATED_CLASS, {
        [MISSING_CLASS]: missingMessage,
      })}
      {...props}
      {...translatedProps}
    />
  );
};

TranslatedField.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(TranslatedField);
